import Chart from "@/chart-setup";
import type { ChartConfiguration } from "chart.js";
import { onBeforeUnmount, type Ref } from "vue";

/**
 * Owns one Chart.js instance bound to a canvas ref: `render` replaces the previous chart (Chart.js
 * never auto-destroys, so listeners and animations would otherwise keep running against a stale
 * canvas) and the instance is destroyed with the component.
 */
export function useChartCanvas(canvasRef: Ref<HTMLCanvasElement | null>) {
  let chart: Chart | null = null;

  const destroy = () => {
    chart?.destroy();
    chart = null;
  };

  const render = (config: ChartConfiguration) => {
    destroy();
    const ctx = canvasRef.value?.getContext("2d");
    if (!ctx) return;
    chart = new Chart(ctx, config);
  };

  onBeforeUnmount(destroy);

  return { render, destroy };
}
